import {connect} from "react-redux";
import HthTeam from "./HthTeam.jsx";
import {hthSearchUpdateAction, hthFetchTeamAction} from "./headToHeadActions";

const mapStateToProps = (state, ownProps) => {
    const otherPositionState = state.headToHead.teams[ownProps.position == 'left' ? 'right' : 'left'];
    const positionState = state.headToHead.teams[ownProps.position];
    return {
        team: positionState.team,
        columns: state.headToHead.columns.filter(col => col.type !== 'in' && col.type !== 'out'),
        teamsList: positionState.search,
        position: ownProps.position,
        otherTeam: {
            sportsmen: otherPositionState.sportsmenIds,
            predictions: otherPositionState.team && otherPositionState.team.predictions
        },
        subleagues: state.headToHead.subleagues,
        subleaguesOpen: state.headToHead.subleaguesOpen,
        classifications: state.classifications.general,
        ownTeams: state.teamDetails.ownTeams
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSearch: (position, classId, subleagueId, subleagueOpenId) => dispatch(
            hthSearchUpdateAction(position, classId, subleagueId, subleagueOpenId)),
        onTeamClick: (id, position) => {
            dispatch(hthFetchTeamAction(id, position))
        }
    }
};

const HthTeamContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HthTeam);

export default HthTeamContainer